var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachmentZip = function SvgAttachmentZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    fillRule: "evenodd",
    d: "M12 7.5A1.5 1.5 0 0 0 10.5 9v8.25h3V7.5H12Zm1.5 23.25h-3v9.75A1.5 1.5 0 0 0 12 42h24a1.5 1.5 0 0 0 1.5-1.5v-.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M13.5 30.75h.75v7.5c0 .414.336.75.75.75h24a.75.75 0 0 0 .75-.75V14.155l-.244-.28H33V6.393L32.658 6H15a.75.75 0 0 0-.75.75v10.5h-.75V6.75a1.5 1.5 0 0 1 1.5-1.5h18l7.5 8.625V38.25a1.5 1.5 0 0 1-1.347 1.492L39 39.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    fillRule: "evenodd",
    d: "M14.25 32.75v5.5c0 .414.336.75.75.75h24a.75.75 0 0 0 .75-.75V14.155l-.244-.28H33V6.393L32.658 6H15a.75.75 0 0 0-.75.75v10.5h12.755c.621 0 1.125.504 1.125 1.125v11.25c0 .034-.002.068-.005.102v1.023a1.5 1.5 0 0 1-1.5 1.5H14.25v-1.5 2Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D7DB",
    d: "M14.25 35.25h2.25v1.5h-2.25v-1.5ZM16.5 36.75h3v1.5h-3zM19.5 35.25h3v1.5h-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M22.5 36.75h3v1.5h-3zM25.5 35.25h3v1.5h-3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M28.5 36.75h3v1.5h-3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F636B",
    d: "M31.5 35.25h3v1.5h-3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M14.25 30.75h12.755c.586 0 1.067-.45 1.12-1.023v1.023a1.5 1.5 0 0 1-1.5 1.5H14.25v-1.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9961D",
    fillRule: "evenodd",
    d: "M9.005 17.25h18c.621 0 1.125.504 1.125 1.125v11.25a1.128 1.128 0 0 1-1.125 1.125H9.005a1.125 1.125 0 0 1-1.125-1.125v-11.25c0-.621.504-1.125 1.125-1.125Zm10.66 3.262v6.363h1.142v-2.153h1.23c1.469 0 2.255-.884 2.26-2.1-.005-1.223-.782-2.11-2.242-2.11h-2.39Zm-1.187 0v6.363h-1.142v-6.363h1.142Zm-6.89 5.642v.721h4.71v-.967h-3.286l3.27-4.684v-.712H11.57v.958h3.287l-3.27 4.684Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9961D",
    d: "M20.807 23.781h1.073c.861-.004 1.248-.487 1.248-1.16 0-.681-.387-1.151-1.248-1.151h-1.073v2.311Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.665 26.875v-6.363h2.39c1.46 0 2.237.887 2.242 2.11-.005 1.216-.791 2.1-2.26 2.1h-1.23v2.153h-1.142Zm3.463-4.254c0 .673-.387 1.156-1.248 1.16h-1.073V21.47h1.073c.861 0 1.248.47 1.248 1.151Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.478 26.875v-6.363h-1.142v6.363h1.142ZM11.588 26.154v.721h4.71v-.967h-3.286l3.27-4.684v-.712H11.57v.958h3.287l-3.27 4.684Z"
  })));
};
export default SvgAttachmentZip;